import styled from '@emotion/styled'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import theme from 'theme'

export const StyledFormControlLabel = styled(FormControlLabel)`
  width: 100%;
  margin: 0;
  pointer-events: none;

  & .MuiTypography-root {
    transform: translateY(1px);
    flex: 1;
  }
`

export const StyledCheckbox = styled(Checkbox)`
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  margin-right: ${theme.spacing.xSmall}px;
  color: rgba(255, 255, 255, 0.5);

  html[data-theme='light'] & {
    color: ${theme.colors.checkboxUnchecked};
  }

  &.Mui-checked {
    color: ${theme.colors.neutral};

    html[data-theme='light'] & {
      color: ${theme.colors.cta};
    }
  }

  &.MuiCheckbox-indeterminate {
    color: ${theme.colors.neutral};

    html[data-theme='light'] & {
      color: ${theme.colors.cta};
    }

    & .MuiSvgIcon-root {
      color: ${theme.colors.neutral};

      html[data-theme='light'] & {
        color: ${theme.colors.cta};
      }
    }
  }
`
